import initVueApp from "@/core.js";
const component = require(`./../views/Approach.vue`).default;
initVueApp(component);
